<template>
    <div v-if="campaignList.length" class="w-full mx-auto pt-40 lg:j-w-1180 lg:j-pt-80 lg:j-pb-50 bg-#ffffff lg:(bg-transparent)">
        <a-carousel arrows draggable autoplay>
            <template #prevArrow>
                <div class="!hidden !lg:block custom-slick-arrow slick-left-arrow">
                    <left-outlined />
                </div>
            </template>
            <template #nextArrow>
                <div class="!hidden !lg:block custom-slick-arrow slick-right-arrow">
                    <right-outlined />
                </div>
            </template>
            <div class="w-full min-h-1000 lg:j-min-h-600 relative" v-for="item in campaignList">
              <template v-if="item.campaignBtnName">
                <img v-if="item.campaignImgMob" class="lazyload !block !lg:hidden w-full h-1000 object-cover" :data-src="item.campaignImgMob" alt="">
                <img v-if="item.campaignImg" class="lazyload !hidden !lg:block w-full lg:j-h-600 object-cover" :data-src="item.campaignImg" alt="">  
              
                <div class="w-full px-70 lg:px-0 lg:j-px-80 !lg:j-w-1180 lg:j-round-16 lg:j-h-600 absolute left-0 lg:left-1/2 top-0 lg:-translate-x-1/2 flex cursor-pointer flex-col justify-start lg:justify-center mt-95 lg:mt-0 text-left">
                    <h2
                        v-if="item.titleShow !== 'NO'"
                        class="w-full text-72 leading-80 text-soft Poppins-SemiBold font-semibold break-words lg:(j-text-40 j-leading-48) line-clamp-3"
                        v-html="item.campaignTitle"
                    ></h2>
                    <p
                        v-if="item.descShow !== 'NO'"
                        class="text-28 leading-44 Poppins-Medium font-medium text-#F5F5F5/80 mt-40 line-clamp-5
                        lg:(j-text-20 j-leading-28 j-mt-16 line-clamp-3)"
                        :title="item.campaignDesc"
                        v-html="item.campaignDesc"
                    ></p>
                    <p
                        v-if="item.timeShow !== 'NO'"
                        class="text-28 leading-44 Poppins-Medium font-medium text-#F5F5F5/80 mt-40
                        lg:(j-text-20 j-leading-28 j-mt-8)"
                    >{{ `${item.startedAtDesc} - ${item.endedAtDesc}` }}</p>
                    <div class="flex flex-col items-start justify-start gap-y-40 mt-60 lg:(flex-row items-center j-gap-x-30 j-mt-20)">
                        <!-- <span
                          v-if="!props.isLogin"
                          class="button-base bg-primary text-white"
                          @click.prevent="acrossDomainJump('register')"
                        >{{ t('member_index.common.register') }}</span> -->
                        <span
                          v-if="item.campaignUrl && item.campaignBtnName"
                          class="button-base border-4 lg:j-border-2 !border-solid  border-primary 11111"
                          :class="[props.isLogin? 'bg-primary text-white' : 'bg-transparent text-primary']"
                          @click.prevent="openUrl(item.campaignUrl)"
                        >{{ item.campaignBtnName }}</span>
                    </div>
                </div>
              </template>
              <template v-else>
                <div @click.prevent="openUrl(item.campaignUrl)">
                  <img v-if="item.campaignImgMob" class="lazyload !block !lg:hidden w-full h-1000 object-cover" :data-src="item.campaignImgMob" alt="">
                  <img v-if="item.campaignImg" class="lazyload !hidden !lg:block w-full lg:j-h-600 object-cover" :data-src="item.campaignImg" alt="">  
                  <div class="w-full px-70 lg:px-0 lg:j-px-80 !lg:j-w-1180 lg:j-h-600 absolute left-0 lg:left-1/2 top-0 lg:-translate-x-1/2 flex cursor-pointer flex-col justify-start lg:justify-center mt-95 lg:mt-0 text-left">
                      <h2
                          v-if="item.titleShow !== 'NO'"
                          class="w-full text-72 leading-80 text-soft Poppins-SemiBold font-semibold break-words lg:(j-text-40 j-leading-48) line-clamp-3"
                          v-html="item.campaignTitle"
                      ></h2>
                      <p
                          v-if="item.descShow !== 'NO'"
                          class="text-28 leading-44 Poppins-Medium font-medium text-#F5F5F5/80 mt-40 line-clamp-5
                          lg:(j-text-20 j-leading-28 j-mt-16 line-clamp-3)"
                          :title="item.campaignDesc"
                          v-html="item.campaignDesc"
                      ></p>
                      <p
                          v-if="item.timeShow !== 'NO'"
                          class="text-28 leading-44 Poppins-Medium font-medium text-#F5F5F5/80 mt-40
                          lg:(j-text-20 j-leading-28 j-mt-8)"
                      >{{ `${item.startedAtDesc} - ${item.endedAtDesc}` }}</p>
                      <!-- <div class="flex flex-col items-start justify-start gap-y-40 mt-60 lg:(flex-row items-center j-gap-x-30 j-mt-20)">
                          <span
                            v-if="!props.isLogin"
                            class="button-base bg-primary text-white"
                            @click.prevent="acrossDomainJump('register')"
                          >{{ t('member_index.common.register') }}</span>
                      </div> -->
                  </div>
                </div>
              </template>
            </div>
        </a-carousel>
    </div>
</template>

<script setup>
import { LeftOutlined, RightOutlined, } from '@ant-design/icons-vue';
import { getCampaignList, } from '@a/index';
import { onMounted, ref, } from 'vue';
import { cookie, } from "@u/common";
import { shopLists } from "@a/userCommon";

const { t } = useI18n()

const props = defineProps({
    isLogin: Boolean
})

const SHOP_ID = cookie.get("_jk_shop_id") || localStorage.getItem('JACKERY_ID_SHOP_ID')

const campaignList = ref([])

const getShopId = async () => {
    const { current: { shop_id, }, } = await shopLists()
    return shop_id
}

onMounted(async () => {
  if (!SHOP_ID) {
    getShopId().then(async shop_id => {
      const data = await getCampaignList({ shopId: shop_id, })
      campaignList.value = (data || []).map(it => ({
        ...it,
        startedAtDesc: it?.startedAtDesc?.split(' ')[0],
        endedAtDesc: it?.endedAtDesc?.split(' ')[0],
      }))
    })
    return
  }

  const data = await getCampaignList({ shopId: SHOP_ID, })
  campaignList.value = (data || []).map(it => ({
    ...it,
    startedAtDesc: it?.startedAtDesc?.split(' ')[0],
    endedAtDesc: it?.endedAtDesc?.split(' ')[0],
  }))
})

// 跨域名 跳转
const acrossDomainJump = route => {
  if (window.location.origin.includes('localhost')) {
    router.push({ path: `/${route}`, query: { redirect: '/index'} })
  } else {
    window.location.href = `${import.meta.env.VITE_ID_URL}/${route}?redirect=/index`
  }
}

const openUrl = url => {
  if(url) {
    window.open(url)
  }
}
</script>

<style scoped >
.button-base {
  @apply
    w-auto min-w-260 px-40 min-h-80 lg:j-min-w-150 lg:j-px-24 lg:j-min-h-50 flex-center rounded-full text-32 lg:j-text-20
    Poppins-Medium font-medium cursor-pointer hover:bg-#fd5000 hover:text-white transition-all duration-300 border-none;

}
.ant-carousel :deep(.slick-list) {
  @apply lg:j-rounded-16
}
.ant-carousel :deep(.slick-slide) {
  @apply text-center h-full 
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
    @apply lg:j-w-60 lg:j-h-60 bg-white rounded-full text-#9A9A9A text-8 hover:text-primary !lg:flex-center lg:j-text-22
}
.slick-left-arrow {
  @apply z-1 lg:left-1/2 -lg:j-ml-710
}
.slick-right-arrow {
  @apply z-1 lg:right-1/2 -lg:j-mr-710
}
.ant-carousel :deep(.custom-slick-arrow:before) {
  @apply hidden
}
/* .ant-carousel :deep(.custom-slick-arrow:hover) {
  @apply opacity-50
} */
.ant-carousel :deep(.slick-slide) {
  @apply text-white
}
.ant-carousel :deep(.slick-dots li) {
  @apply w-30 lg:j-w-30 
}
.ant-carousel :deep(.slick-dots li.slick-active) {
  @apply w-50 lg:j-w-50
}

.ant-carousel :deep(.slick-dots li.slick-active) {
  @apply w-50 lg:j-w-50
}
.ant-carousel :deep(.slick-dots-bottom) {
  @apply -bottom-50 -lg:j-bottom-50
}
.ant-carousel :deep(.slick-dots li button) {
 
  @apply bg-info lg:bg-#ffffff opacity-100
}

.ant-carousel :deep(.slick-dots li.slick-active button) {
  @apply bg-primary
}
</style>
